import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 24
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  return <div className="flex items-center justify-center space-x-2 text-3xl md:text-5xl font-black text-brand tracking-tighter tabular-nums" data-id="element-127">
      <div className="flex flex-col items-center" data-id="element-128">
        <span data-id="element-129">{formatNumber(timeLeft.hours)}</span>
        <span className="text-xs text-gray-400 font-medium uppercase tracking-widest mt-1" data-id="element-130">
          hs
        </span>
      </div>
      <span className="text-gray-600 pb-5" data-id="element-131">:</span>
      <div className="flex flex-col items-center" data-id="element-132">
        <span data-id="element-133">{formatNumber(timeLeft.minutes)}</span>
        <span className="text-xs text-gray-400 font-medium uppercase tracking-widest mt-1" data-id="element-134">
          min
        </span>
      </div>
      <span className="text-gray-600 pb-5" data-id="element-135">:</span>
      <div className="flex flex-col items-center" data-id="element-136">
        <span data-id="element-137">{formatNumber(timeLeft.seconds)}</span>
        <span className="text-xs text-gray-400 font-medium uppercase tracking-widest mt-1" data-id="element-138">
          seg
        </span>
      </div>
    </div>;
}